const payload = {
  'IT Service Management': {
    assetId: '3649343',
    customFields: {
      cf_product: 'Freshservice',
      cf_source: 'Demo Request',
      cf_campaign: 'Demo Request',
      cf_freshmarketer_list: '18000006116'
    }
  },
  'Customer Service & Support': {
    assetId: '3649340',
    customFields: {
      cf_product: 'Freshdesk',
      cf_subproduct: 'Freshdesk Omnichannel',
      cf_source: 'Demo Request',
      cf_engagementstatus: 'Other Marketing Sources - Engaged/ Requested follow up',
      cf_campaign: 'Demo Request',
      cf_campaigndate: '',
      cf_freshmarketer_list: '18000003740'
    }
  },
  'Conversational Engagement': {
    assetId: '3649341',
    customFields: {
      cf_freshmarketer_list: '18000004403',
      cf_product: 'Freshchat',
      cf_source: 'Demo Request',
      cf_engagementstatus: 'Other Marketing Sources - Engaged/ Requested follow up',
      cf_campaign: 'Demo Request',
      cf_marketingcampaign: 'mc'
    }
  },
  'Sales automation': {
    assetId: '4021273',
    customFields: {
      cf_freshmarketer_list: '18000005984',
      cf_subproduct: 'Freshsales',
      cf_source: 'Demo Request',
      cf_product: 'Freshworks CRM',
      cf_engagementstatus: 'A',
      cf_campaign: 'Demo Request',
      cf_marketingcampaign: 'mc'
    }
  },
  'Marketing automation': {
    assetId: '4021273',
    customFields: {
      cf_freshmarketer_list: '18000005984',
      cf_subproduct: 'Freshmarketer',
      cf_source: 'Demo Request',
      cf_product: 'Freshworks CRM',
      cf_engagementstatus: 'A',
      cf_campaign: 'Demo Request'
    }
  }
};

const getPayload = (solutionOfInterest = '') => {
  switch (solutionOfInterest) {
    case 'IT Service Management':
    case 'IT-Service-Management':
    case 'Hantering av IT-tjänster':
    case 'Gestión de servicios de TI':
    case 'Gestion des services informatiques':
    case 'Gerenciamento de Serviços de TI':
      return payload['IT Service Management'];

    case 'Customer Service & Support':
    case 'Kundenservice & Support':
    case 'Kundtjänst och support':
    case 'Servicio y soporte al cliente':
    case 'Service & Support Client':
    case 'Atendimento e suporte ao cliente':
      return payload['Customer Service & Support'];

    case 'Conversational Engagement':
    case 'Konversations-Engagement':
    case 'Interacción conversacional':
    case 'Engagement conversationnel':
    case 'Charlas concertadas':
    case 'Conversational engagement':
      return payload['Conversational Engagement'];

    case 'Sales automation':
    case 'Vertriebsautomatisierung':
    case 'Automatisering av försäljning':
    case 'Automatización de ventas':
    case 'Automatisation des ventes':
    case 'Automação de vendas':
      return payload['Sales automation'];

    case 'Marketing automation':
    case 'Marketingautomatisierung':
    case 'Automatización de marketing':
    case 'Automação de marketing':
      return payload['Marketing automation'];
  }
};

module.exports = { getPayload };
